import { celebrate } from "./celebrationBus";
import { pickCelebration, type CelebrationCandidate } from "./celebrationRules";
import { loadSeen, markSeen } from "./celebrationSeen";

/**
 * Counterparty side. Called from useNotifications' fetch success, so it rides
 * the existing 10s poll with no request of its own. Several components run
 * that hook; repeats are no-ops because every candidate is marked consumed.
 */
export function feedCelebrations(userId: string, notifications: CelebrationCandidate[]): void {
  try {
    // The poll keeps running in a background tab, where the confetti's frames
    // are paused and the toast times out unseen. Leave the keys unconsumed so
    // the first poll after the tab is back plays it.
    if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
    const { watermark, keys } = loadSeen(userId);
    const { celebration, consumed, workerJobEnded, workerQuestId } = pickCelebration(notifications, new Set(keys), watermark);
    if (consumed.length) markSeen(userId, consumed);
    if (celebration) {
      celebrate(celebration.kind, celebration.entityId, "notification", { workerJobEnded, workerQuestId });
    }
  } catch (err) {
    console.debug("[celebrations] feed failed", err);
  }
}
